import { actionCreator } from 'utils';
import * as ImportTypes from '../types/importTypes';

// L O A D   I M P O R T S
export function loadImports(data) {
    return {
        type: ImportTypes.LOAD_IMPORTS,
        data,
    };
}

export function loadImportsRes(data) {
    return {
        type: actionCreator(ImportTypes.LOAD_IMPORTS, 'res'),
        data,
    };
}

export function loadImportsErr() {
    return {
        type: actionCreator(ImportTypes.LOAD_IMPORTS, 'err'),
    };
}
// L O A D   I M P O R T S


// P A G I N A T I O N ,   F I L T E R S ,   S O R T   &   R E S E T
export function setImportFilters(key, value) {
    return {
        type: ImportTypes.SET_IMPORT_FILTER,
        key,
        value,
    };
}

export function setImportPagination(key, pagination) {
    return {
        type: ImportTypes.SET_IMPORT_PAGINATION,
        key,
        pagination,
    };
}

export function setImportSort(sort) {
    return {
        type: ImportTypes.SET_IMPORT_SORT,
        sort,
    };
}

export function resetImportFilters() {
    return {
        type: ImportTypes.RESET_IMPORT_FILTERS,
    };
}
// P A G I N A T I O N ,   F I L T E R S ,   S O R T   &   R E S E T


// A D D   N E W   I M P O R T
export function addNewImport(data) {
    return {
        type: ImportTypes.ADD_NEW_IMPORT,
        data,
    };
}

export function addNewImportRes(loading) {
    return {
        type: actionCreator(ImportTypes.ADD_NEW_IMPORT, 'res'),
        loading,
    };
}

export function addNewImportErr() {
    return {
        type: actionCreator(ImportTypes.ADD_NEW_IMPORT, 'err'),
    };
}
// A D D   N E W   I M P O R T
